<template>
<v-dialog
    v-model="dialog"
    max-width="920"
    v-if="value != null"
>
    <v-card>
        <v-card-title>Edit Agreement</v-card-title>

        <v-card-text>
            <v-select
                label="Context"
                :items="$rc.enumChoices('consent_agreement_context',false)"
                v-model="value.context"
            />

            <v-text-field
                label="Label"
                v-model="value.label"
            />

            <v-checkbox
                v-model="value.is_archived"
                label="Archived"
                style="margin-top: -15px"
            />

            <v-textarea
                label="Specimen"
                v-model="value.agreement_text"
                rows="1"
                auto-grow
            />

            <v-select
                label="Effect on Conversation Consent"
                :items="consent_choices"
                v-model="value.effect_conversational"
            />

            <v-select
                label="Effect on Informational Consent"
                :items="consent_choices"
                v-model="value.effect_informational"
            />

            <v-select
                label="Effect on Promotional Consent"
                :items="consent_choices"
                v-model="value.effect_promotional"
            />
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>


const _ = require('lodash');
export default {

    data() {
        return {
            value: null,
            dialog: false,

            consent_choices: [
                {'text': 'Grant', 'value': 'grant'},
                {'text': 'Deny', 'value': 'deny'},
                {'text': 'No Change', 'value': 'no-record'},
            ],
        }
    },

    methods: {

        showDialog(value)
        {
            this.value = _.cloneDeep(value);
            this.dialog = true;
        },

        onOk()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/consent/consent-agreement',
            
                'params' : this.value,
            
                'on_success': (data) => {
                        this.dialog = false;
                        this.$emit('ok');
                    },
            
                'on_error': 'Unable to save changes to custom consent agreement',
            });

            
        },

        onCancel()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>